import React, { useCallback, useRef, useState, useEffect, memo } from 'react';
import { GoogleMap, DirectionsRenderer } from '@react-google-maps/api';
import AppConfig from '../../AppConfig';
import * as YStyled from '../../Styleds';

const MapRoute = ({ origin, destination, width = '100%', height = '30vh', showBtn = false }) => {
  const directionsRenderer = useRef(null);
  const [map, setMap] = useState(null);

  const onLoad = useCallback(map => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const directionsCallback = (response, status) => {
    if (status === 'OK') {
      const renderer = directionsRenderer.current;
      renderer.setDirections(response);

      const route = response.routes[0];
      const bounds = new window.google.maps.LatLngBounds();
      bounds.union(route.bounds);

      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const extendedBounds = {
        north: ne.lat() + (ne.lat() - sw.lat()),
        south: sw.lat() - (ne.lat() - sw.lat()),
        east: ne.lng() + (ne.lng() - sw.lng()),
        west: sw.lng() - (ne.lng() - sw.lng())
      };

      if (renderer.map) {
        renderer.map.fitBounds(extendedBounds);
      }
    } else {
      console.error(`Directions request failed due to ${status}`);
    }
  };

  useEffect(() => {
    console.log("origin",origin)
    console.log("destination",destination)
    if (destination && map) {
      const directionsService = new window.google.maps.DirectionsService();
      const directionsOptions = {
        destination: destination,
        origin: origin,
        travelMode: 'DRIVING'
      };
      directionsService.route(directionsOptions, directionsCallback);
    }
  }, [destination, map, origin]);

  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
  };

  const handleNavigationClick = () => {
    const navigationUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
    window.open(navigationUrl, '_blank');
  };

  return (
    <GoogleMap
      mapContainerStyle={{ width: width, height: height }}
      center={destination}
      zoom={10}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={mapOptions}
    >
      {destination && (
        <DirectionsRenderer
          options={{ suppressMarkers: true, polylineOptions: { strokeColor: "#1565c0", strokeOpacity: 0.8 } }}
          onLoad={(renderer) => {
            directionsRenderer.current = renderer;
          }}
        />
      )}
      {(showBtn&&destination&&origin) && (
        <YStyled.BTN4 style={{ position: "absolute", right: ".5rem", bottom: ".5rem" }} onClick={handleNavigationClick}>
          <YStyled.Row style={{ padding: ".2rem .4rem" }} gap=".4rem">
            <YStyled.Span size={17} fontWeight={400} color="#fff">導航</YStyled.Span>
            <img src="./assets/ui/arrowRightSymbol.png" alt="arrow" />
          </YStyled.Row>
        </YStyled.BTN4>
      )}
    </GoogleMap>
  );
};

export default memo(MapRoute);
